/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2022, Zumper
 */

import * as Api from '@zcode/nr/es/shared/api'
import type { Dispatch } from 'redux'
import { logger } from '../../../logger'
import { setUnreadCounts } from '../actions/index'

let timeout: ReturnType<typeof setTimeout>

export const loadUnreadCount =
  () =>
  async (
    dispatch: Dispatch
  ): Promise<{ landlordUnreadCount: number; renterUnreadCount: number } | undefined> => {
    try {
      const unreadCountsResponse = await Api.unreadCounts.get()
      const {
        // @ts-expect-error
        retryAfter,
        landlordUnreadCount,
        renterUnreadCount,
      } = unreadCountsResponse || {}
      const unreadCounts = {
        landlordUnreadCount: landlordUnreadCount || 0,
        renterUnreadCount: renterUnreadCount || 0,
      }
      dispatch(setUnreadCounts(unreadCounts))
      if (retryAfter) {
        if (timeout) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(() => {
          void dispatch(loadUnreadCount())
        }, retryAfter * 1000)
      }
      return unreadCounts
    } catch (e) {
      logger.error('Failed to get unread counts', e)
    }
  }
